import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const UpdateFamilyMemberMutation = graphql.persisted(
  "UpdateFamilyMember",
  graphql(`
    mutation UpdateFamilyMember($input: UpdateFamilyMemberInput!) {
      updateFamilyMember(input: $input) {
        familyMember {
          person { id firstName lastName }
          role
          isPrimary
        }
        userErrors { message path }
      }
    }
  `)
);

export { UpdateFamilyMemberMutation };

export function useUpdateFamilyMember() {
  return useMutation(UpdateFamilyMemberMutation);
}
